

import { Form, Input } from "decorator-form";

import ContainerLink from "common/views/menuTree/linkTypes/ContainerLink";
import CurrentPageContainerLink from "common/views/menuTree/linkTypes/CurrentPageContainerLink";
import PageLink from "common/views/menuTree/linkTypes/PageLink";
import StaticLink from "common/views/menuTree/linkTypes/StaticLink";
import INavMenuConfig from "common/views/menuTree/NavMenuConfig";
import { NavMenuField } from "common/views/menuTree/NavMenuField";

/**
 * @overview: MenuPanel config class
 * @author: jesposito
 */

const menuInput = NavMenuField.registerWithTypes([PageLink, StaticLink, ContainerLink, CurrentPageContainerLink]);

@Form({title: "Menu Panel"})
export default class MenuConfig {

	@Input({type: menuInput, title: "Menu"})
	public links: INavMenuConfig;

}



// WEBPACK FOOTER //
// ./src/panels/menu/MenuConfig.ts